import React from 'react';
import { Card } from 'react-bootstrap';

import Meta from '../utils/Meta';

function CiteUs() {
  return (
    <div className="m-auto w-4/5 md:w-2/3 lg:w-1/2 ">
      <Meta
        description="Publication describing chemcalc."
        keywords="DOI, reference, publication"
        title="Cite us"
        pageViewKey="citeUS"
      />
      <div className="flex justify-center w-full">
        <h2 className="atom-heading">CITE US</h2>
      </div>

      <Card
        className="text-grey-500 p-4"
        style={{
          boxShadow:
            '0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12)',
          background: '#ffffffb3',
        }}
      >
        <p>If you are using our tools please don&apos;t forget to cite us: </p>

        <p>
          ChemCalc: a building block for tomorrow’s chemical infrastructure.
          Patiny, Luc; Borel, Alain{' '}
          <i>Journal of Chemical Information and Modeling </i> 2013. DOI:
          <a target="blank" href="https://dx.doi.org/10.1021/ci300563h">
            <span style={{ color: '#0000ff9e' }}>10.1021/ci300563h</span>
          </a>
        </p>
      </Card>

      <div className="logo-a">
        <p className="text-center mb-0 mt-4 text-white font-bold">
          This tool is provided by
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center">
          <a
            className=" bg-white mx-4 my-4 py-2  px-6 rounded-lg  block"
            target="blank"
            href="https://www.zakodium.com"
          >
            <img
              src="images/zakodium.png"
              alt="Zakodium logo"
              style={{ height: '70px' }}
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default CiteUs;
